module.exports = __webpack_public_path__ + "img/mobilepainpoint5.ad324b61.png";